






































































































































import CFMDialog from '@/scripts/CFMDialog'
import {Component} from 'vue-property-decorator';

import colorpicker from '@/components/shared/colorpicker.vue';
import timepicker from '@/scripts/global/timepicker';
import CFMMultiselect from '@/components/partials/CFMMultiselect.vue';
import { mixinz } from '@/scripts/global/mixinz';
import * as dateFormat from '@/helpers/dateFormat';
import moment from 'moment';

import * as blockui from '@/helpers/block-ui'

import {required} from "vuelidate/lib/validators";

import {CFMDTOShiftType, CFMDTOColor, CFMDTOCoverageRule, CFMCoreEntityComboSource } from '@/scripts/services/ClientApiAuto'

/** Rol secici + adet kutusunun gecici tasiyicisi; kaydedilen sey coverageRules listesidir. */
interface NewRuleDraft {
    RoleId: number | null;
    Role: { Id?: number, Text?: string } | null;
    MinCount: number;
    EffectiveFrom: string;
}

/**
 * Tarih seciciye baglanan model EKRAN bicimini tutar (uygulamadaki butun tarih alanlari gibi
 * gun.ay.yil); kabloya cikarken ISO'ya cevrilir. Sabit mixinz.pickerDateFormat ile ayni degeri
 * tasiyor - o modul kapsamindan erisilemedigi icin burada tekrar yaziliyor.
 */
const DISPLAY_FORMAT = 'DD.MM.YYYY';

const toDisplayDate = (value?: string | Date) => moment(value).format(DISPLAY_FORMAT);
const toWireDate = (display?: string) => dateFormat.postDateFormat(moment(display, DISPLAY_FORMAT).toDate());

/**
 * "Gecmis" sinirinin tek tanimi. Hem tarih secicinin alt siniri hem de "bu kural artik
 * duzenlenemez" karari bunun uzerinden veriliyor; iki ayri yerde yazilsalardi sessizce ayrisirlardi.
 */
const startOfToday = () => moment().startOf('day');
const isPastDay = (display?: string) => !!display && moment(display, DISPLAY_FORMAT).isBefore(startOfToday());

const emptyRule = (): NewRuleDraft => ({
    RoleId: null,
    Role: null,
    MinCount: 1,
    EffectiveFrom: toDisplayDate(new Date()),
});

@Component<ShiftTypeDialog>({
    components: {
        'colorpicker': colorpicker,
        'timepicker': timepicker,
        'cfm-multiselect': CFMMultiselect,
    },
    mixins: [mixinz],
    validations() {
        return {
          shiftType:{
              Name: {required},
              StartTime:{required},
              EndTime:{required},
              ColorId: {required}
          }
        }
    },
})
export default class ShiftTypeDialog extends CFMDialog {
    shiftType: CFMDTOShiftType = {Name: ''};
    colorList: CFMDTOColor[] = [];

    /** Vardiya takviminde satiri olan roller; kural yalnizca bunlar icin tanimlanabilir. */
    roleList: CFMCoreEntityComboSource[] = [];
    coverageRules: CFMDTOCoverageRule[] = [];
    newRule: NewRuleDraft = emptyRule();

    async created(){
      blockui.blockModal(this);
      const promises: Promise<any>[] = [
        this.getColorList(),
        this.getRoleList()
      ];
      if(this.isUpdate){
        const res = await this.apiClient.shiftType.shiftTypeGetById({id: <number>this.id});
        this.shiftType = res.data;
        // Tarihler sunucudan ISO geliyor; ekran bicimine cevriliyor, kaydederken geri donuyor.
        this.coverageRules = (this.shiftType.CoverageRules || []).map(x => ({
          ...x,
          EffectiveFrom: toDisplayDate(x.EffectiveFrom),
        }));
      }
      await Promise.all(promises);
      blockui.unBlockModal();
    }

    /** Gecmis tarih secilemez: geriye tarihlenen bir kural, o gunlerde var olmayan bir kurala gore gecmisi olcerdi. */
    get effectiveFromPicker() {
      return {...(<any>this).pickerDate, minDate: startOfToday()};
    }

    /**
     * Baslangic yalnizca kural henuz yururluge girmemisken degistirilebilir. Yururlukteki bir
     * kuralin tarihini oynatmak, bugune kadar yapilmis degerlendirmeyi geriye donuk degistirirdi;
     * yanlis girilmisse satir kaldirilip kaydedilir, sonra yeni tarihle yeniden eklenir.
     */
    isEffectiveFromEditable(rule: CFMDTOCoverageRule) {
      return !rule.Id || !isPastDay(rule.EffectiveFrom);
    }

    /**
     * Rol seciciden "Secmek icin tiklayin." / "Silmek icin tiklayiniz." / "Secildi" ipuclarini
     * kaldirir. mixinz.selectOptions bunlari uygulama genelinde veriyor; burada yalnizca bu
     * secici icin bosaltiliyor, diger ekranlar etkilenmiyor.
     */
    get roleSelectProps() {
      return {'select-label': '', 'deselect-label': '', 'selected-label': ''};
    }

    /** Zaten kural eklenmis roller listeden dusurulur; ayni rol icin ikinci kural olamaz. */
    get selectableRoleList(): CFMCoreEntityComboSource[] {
      const used = this.coverageRules.map(x => x.RoleId);
      return this.roleList.filter(x => used.indexOf(x.Value) < 0);
    }

    onColorChanged(color: CFMDTOColor) {
      this.shiftType.ColorId = color && color.Id ? color.Id : undefined;
    }

    async getColorList(){
      const response = await this.apiClient.common.commonGetColorList();
      if(!response.data.IsSuccess || !response.data.Data){
        throw new Error(response.data.Message? response.data.Message: response.statusText);
      }
      this.colorList = response.data.Data;
    }

    async getRoleList(){
      const response = await this.apiClient.role.roleGetCalendarRoles();
      this.roleList = response.data || [];
    }

    addRule() {
      if (!this.newRule.RoleId) {
        toastr.warning(this.translate('coverage_rule_role_required'));
        return;
      }

      // Ayni rol icin ikinci bir kural olamaz; bunu selectableRoleList sagliyor (eklenen rol
      // seciciden dusuyor). Rol adi da secicinin v-model'e yazdigi nesnede hazir duruyor.
      this.coverageRules.push({
        Id: 0,
        RoleId: <number>this.newRule.RoleId,
        RoleName: this.newRule.Role ? this.newRule.Role.Text : '',
        MinCount: this.newRule.MinCount,
        EffectiveFrom: this.newRule.EffectiveFrom,
      });

      this.newRule = emptyRule();
    }

    /**
     * Satir yalnizca listeden dusurulur, sunucuya "sil" cagrisi yapilmaz: kaydetme sirasinda
     * listede olmayan kurallari backend pasife aliyor. Kaydetmeden vazgecen kullanici hicbir
     * sey kaybetmez.
     */
    removeRule(index: number) {
      this.coverageRules.splice(index, 1);
    }

    async onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
          return;
      }
      let formData:CFMDTOShiftType = {
        Id: this.shiftType.Id,
        Name: this.shiftType.Name,
        ColorId: this.shiftType.ColorId,
        StartTime: this.shiftType.StartTime,
        EndTime: this.shiftType.EndTime,
        CoverageRules: this.coverageRules.map(x => ({
          ...x,
          MinCount: Math.max(0, Number(x.MinCount) || 0),
          EffectiveFrom: toWireDate(x.EffectiveFrom),
        })),
      };
      blockui.blockModal(this);
      try{
        const response  = await this.apiClient.shiftType.shiftTypeSave(formData);
        if (response.data.IsSuccess) {
          toastr.success(this.translate('save_successfully'));
          this.saveSucceeded();
          this.close();
        } else {
          const errorMessage = response.data.Message ? response.data.Message : "Error";
          toastr.error(errorMessage);
        }
      }
      catch(e){
        console.log("err",e)
        toastr.error(e);
      }
      finally{
        blockui.unBlockModal();
      }
    }
}
